import { useRef, useState, useEffect } from "react";

export function useIsTruncated() {
  const ref = useRef<HTMLSpanElement>(null);
  const [truncated, setTruncated] = useState(false);

  useEffect(() => {
    if (ref.current) {
      setTruncated(ref.current.scrollWidth > ref.current.clientWidth);
    }
  }, [ref.current?.textContent]); 

  return { ref, truncated };
}
